import  React,{useEffect, useState} from "react"

export default   (val, delay)=>{
    const [debouncedValue, setDebouncedValue] = useState(val)
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(val), delay || 500)
        return () => {
            clearTimeout(timer)
        }
    }, [val, delay])
    return debouncedValue
}
